import axios from 'axios'
import { getAccessToken } from '@/utils/panelSession'

const DEFAULT_EDITOR_IMAGE_FOLDER = 'cdn.adverport.com/adverportaffiliate/campaigns/description-images'

const resolveUploadedImageUrl = response => response?.data?.localUrl
  || response?.data?.data?.localUrl
  || response?.data?.url
  || response?.data?.data?.url

// eslint-disable-next-line import/prefer-default-export
export const editorContainer = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],

  [{ header: 1 }, { header: 2 }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ direction: 'rtl' }],

  [{ size: ['small', false, 'large', 'huge'] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ['clean'],

  ['link', 'image', 'video'],
]
export const imageHandler = (quillEditor, folder = DEFAULT_EDITOR_IMAGE_FOLDER, callbacks = {}) => {
  const input = document.createElement('input')
  input.setAttribute('type', 'file')
  input.setAttribute('accept', 'image/*')
  input.click()

  input.onchange = async () => {
    const file = input.files?.[0]
    const quill = quillEditor?.quill
    if (file && quill && (!callbacks.isCurrent || callbacks.isCurrent())) {
      try {
        if (callbacks.onStart) callbacks.onStart()
        const formData = new FormData()
        formData.append('file', file)
        formData.append('folder', folder)

        const response = await axios.post(
          `${process.env.VUE_APP_BASE_API_URL2}file/uploadFile`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${getAccessToken()}`,
              'Content-Type': 'multipart/form-data',
            },
          },
        )

        const imageUrl = resolveUploadedImageUrl(response)
        if (!imageUrl) {
          throw new Error('Görsel URL alınamadı.')
        }
        if (callbacks.isCurrent && !callbacks.isCurrent()) return

        const range = quill.getSelection(true) || { index: quill.getLength(), length: 0 }
        quill.insertEmbed(range.index, 'image', imageUrl, 'user')
        quill.setSelection(range.index + 1, 0)
      } catch (error) {
        console.error('Editör görseli yüklenemedi:', error)
        if (callbacks.onError) callbacks.onError(error)
      } finally {
        if (callbacks.onFinish) callbacks.onFinish()
      }
    }
  }
}
